import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Auto3dViewCar({
  color = 'icon.primary',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 15 14' {...props}>
      <Path
        d='M4.65557 6.9898H3.09375'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M10.9446 6.9898H9.38281'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M11.7266 4.64419L13.2876 3.86328'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M2.31182 4.64419L0.75 3.86328'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M4.48181 0.742188C3.7561 0.742262
                 3.12596 1.24198 2.96054 1.94858L2.29688
                 4.78022L2.96054 1.94858C3.12596 1.24198
                 3.7561 0.742262 4.48181 0.742188H9.56327C10.2889
                 0.742062 10.9189 1.24194 11.0838 1.94858L11.7475 4.78022'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M13.2859 6.80782C13.2859 5.65521 12.3524 4.72038
            11.1998 4.71875H2.83981C2.28562 4.71855 1.75407 4.93857 1.36214
            5.33036C0.970199 5.72216 0.75 6.25364 0.75 6.80782V10.34C0.75
            10.7473 1.08015 11.0774 1.48741 11.0774H3.13624C3.5435 11.0774
            3.87365 10.7473 3.87365 10.34V9.34228H8.10267'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M9.57812 11.1869V12.519C9.57812 12.9256 9.90739 13.2555
          10.314 13.2562L13.2639 13.2624C13.4594 13.2623 13.6469 13.1845
          13.7851 13.0462C13.9233 12.9078 14.0008 12.7203 14.0007
          12.5247V9.57753C14.001 9.17088 13.6719 8.84082 13.2652
          8.83984H11.3878C11.1626 8.83984 10.9497 8.94282 10.8098
          9.11935L9.89788 10.2723C9.69141 10.5325 9.57875
          10.8548 9.57812 11.1869Z'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Auto3dViewCar.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Auto3dViewCar
